export enum SupportedOperationsDto {
    ELEM_MATCH = "elem_match",
    EQUALS = 'equals',
    CONTAINS = 'contains',
    NOT_CONTAINS = 'not_contains',
    STARTS_WITH = 'starts_with',
    ENDS_WITH = 'ends_with',
    GTE = 'gte',
    LTE = 'lte'
}